import type { Maybe, AssetType, ImageWithFocalPointType, VideoType } from "@swo/shared";

export function getImages(el: { thumbnail?: Maybe<AssetType>; gallery: Array<ImageWithFocalPointType | VideoType> }) {
  return [...(el.thumbnail ? [el.thumbnail] : []), ...el.gallery].flatMap(i =>
    i.__typename === "UtilityImageWithFocalPoint" ? [i.image] : i.__typename === "Asset" ? [i] : [],
  );
}
